import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = Repository.defaults.baseURL;


export default {
    async getConfigErp () {
        return await Repository.get(`${resource}/erp-config`)
    },
}